import { render, staticRenderFns } from "./Alarms.vue?vue&type=template&id=0ea5274d&scoped=true&"
import script from "./Alarms.vue?vue&type=script&lang=js&"
export * from "./Alarms.vue?vue&type=script&lang=js&"
import style0 from "./Alarms.vue?vue&type=style&index=0&id=0ea5274d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea5274d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VCard,VCardText,VDivider})
